define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/Attribute",
	"csi/xml"
], function(declare,heading,Attribute,xml) {

	// NOTE: Make sure to use Separator="" on root Heading, or else sub-heading will not be resolved correctly

	return declare(Attribute, {
		getBaseHeading: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return sub-heading
			var	sh = h.m_subheadings ? h.m_subheadings[0] : null;
			if (sh && heading.getHeadingRenderer(ctx, sh)) {
				return sh;
			}
			
			return h;
		},
		
		getBaseRenderer: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return base renderer according to sub-heading
			var	sh = h.m_subheadings ? h.m_subheadings[0] : null;
			if (sh) {
				this.renBase = heading.getHeadingRenderer(ctx, sh);
			}

			return this.renBase || this;
		},
		
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: no generic index to last node in container, so filtering not allowed
			return null;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: set context key based on defined subheading
			var	urls = xml.nodeGetAttributeValue(ctx.getNode(), h.m_id);
			if (urls && urls.length) {
				ctx.__popContext = true;
				ctx.pushParams({
					urlNode: urls[urls.length - 1],
					urlParent: ctx.getNodeURL(),
					idRelation: h.m_id
				});
			}
	
			this.inherited(arguments);
		},
	
		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: reset context key
			if (ctx.__popContext) {
				ctx.__popContext = false;
				ctx.pop();
			}

			this.inherited(arguments);
		}
	});
});